import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { PageTreeStateUpdater } from '@confluence/page-tree-refresh-state-container';

export const ContextualCreateContentPopoverMenuLoader: LoadableType<{
	parentId?: string;
	source: string;
	isCreateWhiteboardEnabled?: boolean;
	isCreateDatabaseEnabled?: boolean;
	isCreateSmartLinkEnabled?: boolean;
	isCreateLiveDocEnabled?: boolean;
	isCreateFolderEnabled?: boolean;
	isCreateSlidesEnabled?: boolean;
	onCloseMenu: () => void;
	pageStateUpdater?: PageTreeStateUpdater;
	onItemClick?: () => void;
	parentTitle?: string;
	parentContentType?: string;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContextualCreateContentPopoverMenu" */ './ContextualCreateContentPopoverMenu.tsx'
			)
		).ContextualCreateContentPopoverMenu,
});
